import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-page">
        <div className="brutal-card p-6">
          <p className="overline">Loading…</p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  // v149.31 — People with access to 2+ Linkola accounts (their own bio
  // page and/or brand workspaces they staff for) pick one right after
  // login. The flag is set per session by the backend at login, so this
  // one guard covers every sign-in method.
  if (user.account_choice_pending && location.pathname !== "/choose-account") {
    return <Navigate to="/choose-account" replace />;
  }
  return children;
}
